import React, { useCallback, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { MARKETING_TESTIMONIALS } from "../constants/marketingTestimonials";

const AUTO_MS = 7000;

const TestimonialsCarousel: React.FC = () => {
  const total = MARKETING_TESTIMONIALS.length;
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const go = useCallback(
    (next: number) => {
      setIndex(((next % total) + total) % total);
    },
    [total]
  );

  useEffect(() => {
    if (paused || total <= 1) return;
    const timer = window.setInterval(() => go(index + 1), AUTO_MS);
    return () => window.clearInterval(timer);
  }, [go, index, paused, total]);

  return (
    <div
      className="mkt-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-roledescription="carrossel"
      aria-label="Depoimentos de clientes"
    >
      <div className="mkt-carousel__viewport">
        <div
          className="mkt-carousel__track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {MARKETING_TESTIMONIALS.map((item) => (
            <article key={item.id} className="mkt-carousel__slide" aria-hidden={false}>
              <div className="rounded-[1.75rem] border border-white/10 bg-white/5 px-6 py-8 backdrop-blur sm:px-10 sm:py-10">
                <div className="mb-4 flex justify-center gap-1">
                  {[...Array(5)].map((_, star) => (
                    <Star key={star} className="h-4 w-4 fill-yellow-400 text-yellow-400 sm:h-5 sm:w-5" />
                  ))}
                </div>
                <blockquote className="text-center text-base leading-relaxed text-white/90 sm:text-lg sm:leading-relaxed">
                  &ldquo;{item.quote}&rdquo;
                </blockquote>
                <footer className="mt-6 text-center">
                  <p className="text-sm font-semibold text-[#B8D4C8] sm:text-base">{item.author}</p>
                  {item.handle ? (
                    <p className="mt-1 text-xs text-white/60 sm:text-sm">{item.handle}</p>
                  ) : null}
                </footer>
              </div>
            </article>
          ))}
        </div>
      </div>

      {total > 1 && (
        <>
          <button
            type="button"
            className="mkt-carousel__nav mkt-carousel__nav--prev"
            onClick={() => go(index - 1)}
            aria-label="Depoimento anterior"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button
            type="button"
            className="mkt-carousel__nav mkt-carousel__nav--next"
            onClick={() => go(index + 1)}
            aria-label="Próximo depoimento"
          >
            <ChevronRight className="h-5 w-5" />
          </button>

          <div className="mt-8 flex justify-center gap-2">
            {MARKETING_TESTIMONIALS.map((item, i) => (
              <button
                key={item.id}
                type="button"
                className={`mkt-carousel__dot ${i === index ? "is-active" : ""}`}
                onClick={() => go(i)}
                aria-label={`Ir para depoimento de ${item.author}`}
                aria-current={i === index ? "true" : undefined}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TestimonialsCarousel;
